import { render, staticRenderFns } from "./myApproval.vue?vue&type=template&id=4e9a4f37&scoped=true&"
import script from "./myApproval.vue?vue&type=script&lang=js&"
export * from "./myApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a4f37",
  null
  
)

export default component.exports